import { useState } from "react";
import { Form } from "antd";
import { IdentityVerificationCaseV1ActivityLogInput } from "../generated";

// Define the type for the function passed to the hook
type OnAddUpdateActivity = (values: IdentityVerificationCaseV1ActivityLogInput) => Promise<void>;


const useActivityForm = (onAddUpdateActivity: OnAddUpdateActivity) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  const handleSubmit = async (values: { activityDescription: any; }) => {
    setLoading(true);
    setError(null); // Reset any previous errors

    try {
      await onAddUpdateActivity({
        description: values.activityDescription,
      });
      form.resetFields();
    } catch (err) {
      setError(err); // Handle and set error if needed
      console.error("Error submitting form: ", err);
    } finally {
      setLoading(false);
    }
  };

  return { form, loading, error, handleSubmit };
};

export default useActivityForm;